<template>
  <div class="public-content">
    <h2
      v-if="partners.title"
      class="public-h3 mb-4"
    >
      {{ partners.title }}
    </h2>

    <div class="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 md:justify-between">
      <div
        v-for="(partner, index) in partners.items"
        :key="index"
        class="flex h-14 items-center justify-center"
      >
        <UColorModeImage
          :light="partner.srcL"
          :dark="partner.srcD"
          :alt="partner.alt"
          :width="partner.width"
          :height="partner.height"
          format="webp"
          loading="lazy"
          :class="[partner.large ? 'max-h-14' : 'max-h-10', 'w-auto opacity-80 transition duration-300 hover:opacity-100']"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  withTitle: Boolean,
})

const partners = {
  title: props.withTitle ? 'Ils nous font confiance' : undefined,
  items: PARTNERS,
}
</script>
